import { defineStore } from "pinia";
import { $axios } from "@bloglovin/vue-framework";

export const useSocialNetworksStore = defineStore("social-networks-store", {
  state: () => ({
    socialNetworks: [],
  }),
  getters: {},
  actions: {
    loadSocialNetworks(orgId) {
      this.apiGet("/social-network/accounts", { org_id: orgId }, data => {
        this.socialNetworks = data.social_networks;
      });
    },
    loadSocialNetworksForPublication(publicationId) {
      this.apiGet(`/social-network/publication/${publicationId}/account-statuses`, {}, data => {
        this.socialNetworks = data.social_networks;
      });
    },
    setSocialNetworks(socialNetworks) {
      this.socialNetworks = socialNetworks;
    },
    connect(socialNetworkName, orgId) {
      $axios.post("/social-network/connect", {
        social_network_name: socialNetworkName,
        redirect_uri: `${window.blclient.data.links.web}/social-network/connect?org_id=${orgId}&social_network=${socialNetworkName}`,
      }).then(response => {
        window.open(`${response.data.uri}`, "_self");
      });
    },
    manualConnect(socialNetworkName, orgId, accountHandle) {
      $axios.post("/social-network/manual-connect", {
        org_id: orgId,
        social_network_name: socialNetworkName,
        social_network_account_handle: accountHandle,
      }).then(response => {
        this.socialNetworks = response.data.social_networks;
      });
    },
    disconnect(socialNetworkId, socialNetwork, orgId) {
      $axios.post("/social-network/disconnect", {
        social_network_name: socialNetwork,
        org_id: orgId,
      }).then(response => {
        this.socialNetworks = response.data.social_networks;
      });
    },
    manualDisconnect(socialNetworkId, socialNetwork, orgId) {
      $axios.post("/social-network/manual-disconnect", {
        social_network_name: socialNetwork,
        org_id: orgId,
      }).then(response => {
        this.socialNetworks = response.data.social_networks;
      });
    },
    postMessage(orgId, socialNetwork, postId, successCallback = () => {
    }, errorCallback = () => {
    }) {
      const formData = new FormData();
      formData.append("org_id", parseInt(orgId));
      formData.append("social_network_name", socialNetwork);
      formData.append("post_id", postId);

      $axios.post("/social-network/post",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(response => {
        successCallback(response.data);
      }).catch(error => {
        errorCallback(error);
      });
    },
  },
});
